import type React from 'react';

import { Spinner, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { ResponsiveBox } from 'src/app/pages/petitionDetails/shared/components';

import { PetitionUrlQRCode as PetitionUrlQRCodeSunrise } from '../QRCodeSunrise';

import { ShareLoader } from './ShareLoader';

export const SharePetition: React.FC = () => {
	return (
		<div className="px-0" data-qa="share-section-sunrise">
			<Text as="h2" variant="heading" size="large">
				<Translate value="corgi.petition_gamma.share.title" />
			</Text>
			<div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
				<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
					<PetitionUrlQRCodeSunrise />
				</ClientRender>
				<div className="w-full">
					<ResponsiveBox viewportSize="small">
						<ShareLoader forMobileView />
					</ResponsiveBox>
					<ResponsiveBox viewportSize="normal">
						<ShareLoader forMobileView={false} />
					</ResponsiveBox>
				</div>
			</div>
		</div>
	);
};
